/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiPropertyVendorsListSortBy = typeof GetApiPropertyVendorsListSortBy[keyof typeof GetApiPropertyVendorsListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiPropertyVendorsListSortBy = {
  email: 'email',
  phone: 'phone',
  fullName: 'fullName',
  createdAt: 'createdAt',
  id: 'id',
  businessName: 'businessName',
  contactName: 'contactName',
  priority: 'priority',
  jobsCompleted: 'jobsCompleted',
} as const;
